import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'shared-cart-footer',
    templateUrl: './cart-footer.shared.component.html',
    styleUrls: ['./cart-footer.shared.component.scss']
})
export class CartFooterComponent {
    @Input() public label: string = 'clear your cart';
    @Input() public icon: string = 'remove-for-clear-cart';
    @Input() public iconHover: string = 'removing-for-clear-cart';
    @Input() public feel: OLO.Components.BUTTON_FEEL = 'plain';
    @Input() public size: OLO.Components.BUTTON_SIZE = null;
    @Input() public width: OLO.Components.BUTTON_WIDTH = 'compact';

    @Output() public onClearCartClick: EventEmitter<Event> = new EventEmitter();

    public handleClearCartClick($event: Event): void {
        this.onClearCartClick.emit($event);
    }
}
